import { Grid, Container, useMediaQuery, Stack, Typography, Badge, Box, Link } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { ShoppingCartOutlined, Menu, Close } from '@mui/icons-material';
import getConfig from 'next/config';
import { useTheme } from '@mui/material/styles';
import BrandIcon from '../../shared/BrandIcon.styled';
import MainNavLinks from './MainNavLinks';
import DropdownMobile from './DropdownMobile';
import styles from '../styles';
import RootContext from '../../../../util/root.context';
import { getCartInfo } from '../../eir-cart/cart.util';
import { getLocalStorage } from '../../../hooks/useLocalStorage';

const { publicRuntimeConfig } = getConfig();

const { mainNavStyle } = styles;
const MainNavContainer = ({ nav, leftNav, rightNav, cartCountNumber = 0 }) => {
  const [expand, setExpand] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const mobile = useMediaQuery(theme => theme.breakpoints.down('md'));
  const { state } = useContext(RootContext);
  const router = useRouter();
  const theme = useTheme();
  const handleExpand = () => {
    setExpand(!expand);
  };

  useEffect(() => {
    const cartInfo = getCartInfo(state.cart);
    setCartCount(
      cartInfo.numberOfOffers +
        cartInfo.numberOfDevices +
        cartInfo.numberOfAddOns +
        cartInfo.numberOfInsuranceAddOns
    );
  }, [state?.updateContext]);

  useEffect(() => {
    if (getLocalStorage('STANDALONE_HANDSET')) {
      if (
        state?.cart?.offers?.filter(
          element => element.id === parseInt(getLocalStorage('HANDSET_BE_OFFERID'), 10)
        ).length > 0 &&
        state?.cart?.offers?.filter(element => element.equipments).length > 0
      ) {
        const cartInfo = getCartInfo(state.cart);
        setCartCount(cartInfo.numberOfOffers + cartInfo.numberOfDevices - 1);
      }
    }
  }, [state.updateContext]);

  useEffect(() => {
    if (cartCountNumber > 0) setCartCount(cartCountNumber);
  }, [cartCountNumber]);

  return (
    <Container>
      <Grid container justifyContent='space-between' alignItems='center'>
        <Grid item xs={2}>
          <BrandIcon
            src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}/uploads/eir_logo_f2826fa9d7.png`}
            url={`${publicRuntimeConfig.NEXT_PUBLIC_OPENCMS}`}
          />
        </Grid>
        <Grid item xs='auto' sm={8} md={8} sx={{ display: { xs: 'none', md: 'block' } }}>
          <MainNavLinks navs={nav} />
        </Grid>
        <Grid item xs={3} sm='auto'>
          <Stack direction='row' alignItems='center' justifyContent='flex-end'>
            <Link
              href={`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/redirectSummary`}
              onClick={() => router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/redirectSummary`)}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/redirectSummary`);
                }
              }}
              underline='hover'
              sx={{
                ...mainNavStyle.cartIcon,
                display: 'flex',
              }}
            >
              <Typography sx={styles.navTitle}>{!mobile ? 'My cart' : ''}</Typography>
              {[null, undefined, NaN, 0].includes(cartCount) ? (
                // <ShoppingCartOutlined sx={{ color: theme.palette.secondary.errorCTA }} />
                <Box
                  component='img'
                  alt=''
                  src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}/uploads/Icon_Cart_3caf163f71.svg`}
                />
              ) : (
                <Badge
                  badgeContent={cartCount}
                  sx={{
                    '&.MuiBadge-root .MuiBadge-badge': {
                      background: theme.palette.primary.buttonColor,
                      color: theme.palette.secondary.contrastText,
                    },
                  }}
                >
                  <ShoppingCartOutlined />
                </Badge>
              )}
            </Link>
            {mobile &&
              (expand ? (
                <Box
                  component='button'
                  onClick={handleExpand}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleExpand();
                    }
                  }}
                  sx={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: 0,
                    display: 'flex',
                    alignItems: 'center',
                    '&:hover': {
                      background: 'none',
                    },
                  }}
                >
                  <Close
                    className='--prevent-collapse'
                    aria-label='Close Menu'
                    sx={{ color: '#323435' }}
                  />
                </Box>
              ) : (
                <Box
                  component='button'
                  onClick={handleExpand}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      handleExpand();
                    }
                  }}
                  sx={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: 0,
                    display: 'flex',
                    alignItems: 'center',
                    '&:hover': {
                      background: 'none', // Ensures no background on hover
                    },
                  }}
                >
                  <Menu
                    className='--prevent-collapse'
                    role='navigation'
                    sx={{ color: '#323435' }}
                  />
                </Box>
              ))}
          </Stack>
        </Grid>
        <Grid item xs={12} sx={{ display: { xs: 'block', md: 'none' } }}>
          <DropdownMobile
            nav={nav}
            expand={expand}
            leftNav={leftNav}
            rightNav={rightNav}
            handleExpand={handleExpand}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default MainNavContainer;
